import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { setOpenContentGuidelinesPane } from "src/redux";
import { RootState } from "src/redux/reducers";
import FilePreviewDisplay from "src/app/components/FilePreviewDisplay/FilePreviewDisplay";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import useGetProjectContentGuidelinesData from "../../hooks/useGetProjectContentGuidelinesData";

export default function ContentGuidelinesPreview() {
  const { isLoadingContentGuidelines } = useSelector(
    (state: RootState) => state.projectReducer,
  );
  const dispatch = useDispatch();

  const { contentGuidelinesFileName, contentGuidelinesContent } =
    useGetProjectContentGuidelinesData();

  const handleOpenContentGuidelinesPane = () => {
    dispatch(setOpenContentGuidelinesPane(true));
  };

  const shouldDisplayPreview =
    Boolean(contentGuidelinesFileName) || Boolean(contentGuidelinesContent);

  return (
    <FilePreviewDisplay
      isLoading={isLoadingContentGuidelines}
      fileName={contentGuidelinesFileName}
      shouldDisplayPreview={shouldDisplayPreview}
      onOpenPreview={handleOpenContentGuidelinesPane}
      label={
        <IDHFormattedMessage
          id="ws_content_guidelines"
          defaultMessage="Content guidelines"
        />
      }
    />
  );
}
